import moment from 'moment';
import 'moment/locale/sv';
import { ViewingDto } from '../services/generatedApi';

interface Props {
  viewing: ViewingDto;
  setShowHideModalFunction(val: boolean): void;
  setSelectedViewingFunction(val: string): void;
  whiteText?: boolean;
}
const ViewingItem = ({ viewing, whiteText }: Props): JSX.Element => {
  moment.locale('sv');

  return (
    <div className="flex flex-wrap items-center rounded-md md:w-1/2 lg:w-full pt-2 w-full mx-auto">
      <p className="flex my-0 justify-between w-full">
        <span
          className={`${whiteText ? 'text-white' : 'text-blue700'} font-icb`}
        >
          {moment(viewing.startTime).format('ddd').charAt(0).toUpperCase() +
            moment(viewing.startTime).format('dddd').slice(1)}{' '}
          {moment(viewing.startTime).format('D')}{' '}
          {moment(viewing.startTime).format('MMMM')}{' '}
        </span>
        <span>
          {moment(viewing.startTime).format('HH:mm') !== '00:00' && (
            <span
              className={`${
                whiteText ? 'text-white' : 'text-blue700'
              } font-icb`}
            >
              {moment(viewing.startTime).format('HH:mm')}
              {'-'}
              {moment(viewing.endTime).format('HH:mm') !== '00:00' && (
                <span>{moment(viewing.endTime).format('HH:mm')}</span>
              )}
            </span>
          )}
        </span>
      </p>
      {viewing.commentary &&
      !viewing.fullyBooked &&
      new Date(viewing.noLaterThen) > new Date() ? (
        <p
          className={`${
            whiteText ? 'text-white' : 'text-black500'
          } my-0 text-tiny leading-4 w-full`}
        >
          {viewing.commentary}
        </p>
      ) : (
        new Date(viewing.noLaterThen) < new Date() &&
        !viewing.fullyBooked && (
          <p
            className={`${
              whiteText ? 'text-white' : 'text-black500'
            } my-0 text-tiny leading-4 w-full`}
          >
            Bokning stängd
          </p>
        )
      )}
      {viewing.fullyBooked && (
        <p
          className={`${
            whiteText ? 'text-white' : 'text-black500'
          } my-0 text-tiny leading-4 w-full`}
        >
          Fullbokad
        </p>
      )}
    </div>
  );
};
export default ViewingItem;
